import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=b71fdb86&scoped=true"
import script from "./AddType.vue?vue&type=script&lang=ts"
export * from "./AddType.vue?vue&type=script&lang=ts"
import style0 from "./AddType.vue?vue&type=style&index=0&id=b71fdb86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71fdb86",
  null
  
)

export default component.exports